import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateInvoice } from "../../api/apiInvoices";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useUpdateInvoice = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lang = i18n.language;

    const { mutate: updateInvoiceMutate, isPending } = useMutation({
        mutationFn: ({ id, data }) => updateInvoice(data, id),
        onSuccess: (data, variables) => {
            toast.success(lang === "ar" ? "تم تحديث الفاتورة بنجاح" : "Invoice updated successfully");
            queryClient.invalidateQueries(["programInvoice"]);
            queryClient.invalidateQueries(["program"]);
        },
        onError: (error) => {
            const errorMessage =
                error.response?.data?.message ||
                (lang === "ar" ? "حدث خطأ أثناء تحديث الفاتورة" : "An error occurred while updating the invoice");
            toast.error(errorMessage);
        },
    });

    return { updateInvoiceMutate, isPending };
};

export default useUpdateInvoice;
